<ng-container *ngFor="let message of messageList">
  <div class="form-errors-messages" *ngIf="message && message.show">{{ message.message | translate}}</div>
</ng-container>
